
import center from './assets/icons/center.png';
import batt from './assets/icons/batt.png';

import './assets/scss/App.scss';
import RectangleList from './components/sensors/SensorList';
import React from 'react';
import logo from './assets/images/logo.png';
import { Xwrapper} from 'react-xarrows';
import { fetchConfig } from './utils/FetchConfig';
import { fetchSensors } from './utils/FetchSensors';
import Sum from './components/sum/Sum';
import Legend from './components/legend/Legend';
import {sumAllEnergy} from './components/sum/SumUtils';
//import {calculateSpread} from './components/sensors/SensorUtils';
import HelperDiv from './components/utils/HelperDiv'




class App extends React.Component {

  //todo: map available Energy types to energytypeas and their names
  constructor(props) {
    super(props);  
    this.state = {
      fetching: true,
      rectanglesLeft: [],
      rectanglesRight: [],
      powerTypes:[],
      helperR: [],
      helperL: [],
      distanceLeft: 0,
      distanceRight: 0,
      energy: 0,
      total: 0,
      verbraucher: {
        name: 'batt',
        source: batt
      },
      timeSpan: 'Stunde',
      availableEnergie: [],
      sensorData:[],
      connection:true,
    }
    this.handleTimeSpan = this.handleTimeSpan.bind(this);
  }

  centerDiv = React.createRef();

  componentDidMount = async () =>{
    this.fetchData();
    setInterval(this.fetchData, 120000);
  }

  

  fetchData = async () => {
    let sensorDataQuery;
    let config;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    //todo:Warning if no getters are present
    const baseurl = urlParams.get('baseurl');
    const key = await urlParams.get('key')
    //console.log(key, baseurl)

    try{
    config = await fetchConfig(baseurl,key);

    if (!config.success) {
      this.setState({connection: false});
      return;
    }

    sensorDataQuery = await fetchSensors(config.availableSensors,baseurl,key);

    if (sensorDataQuery.length == 0) {
      this.setState({connection: false});
      return; 
    }

    if (config.success && sensorDataQuery.length > 0){
      this.setState({
        availableEnergie: config.availableEnergie,
        powerTypes: config.powerTypes,
        sensorData:sensorDataQuery
      });
      for (let [key, value] of Object.entries(sensorDataQuery)) { 
        if (value.visuSide === 'left') {
          if
          (! this.state.helperL.includes(value.visuPosition)) { 
            this.addRectangleHandler(value);
          }
        } else {
          if
          (! this.state.helperR.includes(value.visuPosition)) { 
            this.addRectangleHandlerRight(value);
          }
        }
      }
      this.setState({
        fetching: false,
      });


    }
    } catch (e) 
    {console.log(e);}
  }

  addRectangleHandler = (rectangle) => {
    this.setState(prevState => 
    ({
      rectanglesLeft: [...prevState.rectanglesLeft, rectangle],
      helperL: [...prevState.helperL, rectangle.visuPosition],
      distanceLeft: this.calculateViewHeight(this.state.rectanglesLeft.length),
    }),
    );
  }
  addRectangleHandlerRight = (rectangle) => {
    this.setState(prevState => (
      {
      rectanglesRight: [...prevState.rectanglesRight, rectangle],
    }), 
    this.setState(prevState => 
      ({
      helperR: [...prevState.helperR, rectangle.visuPosition],
    })),
    this.setState({
      distanceRight: this.calculateViewHeight(this.state.rectanglesRight.length),
    }));
  }
  calculateViewHeight = (count) => {
    return (100/ (count + 2));
  }

  calculateSum() {
    let sumData;
    let energyIn;
    let energyOut;
    let total;
    sumData = sumAllEnergy(this.state.timeSpan, this.state.sensorData, this.state.availableEnergie);
    energyIn = sumData.sumIn;
    energyOut = sumData.sumOut;
   
    return [energyIn, energyOut]  
  }


  handleTimeSpan = (e) => {
    this.setState({
      timeSpan: e.target.value
    });
  }
  render (){

    let energyIn = this.calculateSum()[0]
    let energyOut = this.calculateSum()[1]
    
    const {fetching, connection} = this.state;
  return (
    <div>{connection? (fetching ? 
      <div>loading...</div>
     : 
    <div className = 'container'>
      <div id="nav"
      style={{
        width: "70%"
      }}
      >
        <select className="form-select w-25 mt-2" onChange={this.handleTimeSpan}>
          // TODO:change values to int
          <option value="Stunde">Stunde</option>
          <option value="Tag">Tag</option>
          <option value="Monat">Monat</option>
          <option value="Jahr">Jahr</option>
          <option value="Total">Total</option>
        </select>
        </div>

        
        <div ref={this.centerDiv} className='center' id="center">
          <div
          style = {{
            position: "relative",
            height: "17vh",
            width: "17vh"
          }}>
          <img
          style = {{
            height: "100%",
            width: "100%"
          }}
           src={center}
          ></img>
          <HelperDiv
          recs = {this.state.rectanglesLeft}
          side = {"Left"}
          center = {this.centerDiv}/>
          <HelperDiv 
          recs = {this.state.rectanglesRight}
          side = {"Right"}
          center = {this.centerDiv}/>
          </div>


          
          <Sum 
          App = {"yes"}
          state={this.state.sensorData}
          energyIn={energyIn}
          energyOut={energyOut}
          />
        
        </div> 

         <Xwrapper>

          <RectangleList 
            direction={"Left"}
            center={this.centerDiv}
            rectangles={this.state.rectanglesLeft}  
            verbraucher={this.state.verbraucher} 
            distance={this.state.distanceLeft}
            timeSpan={this.state.timeSpan}
            availableEnergie={this.state.availableEnergie}
            powerTypes={this.state.powerTypes}
            total = {energyIn}
            left={"50"} />

          <RectangleList
            direction={"Right"}
            center={this.centerDiv}
            rectangles={this.state.rectanglesRight} 
            verbraucher={this.state.verbraucher} 
            distance={this.state.distanceRight}
            timeSpan={this.state.timeSpan}
            availableEnergie={this.state.availableEnergie}
            powerTypes={this.state.powerTypes}
            total = {energyIn}

            
            left={"50"} />
        </Xwrapper> 

        <Legend 
        availableEnergy={this.state.availableEnergie}
        powerTypes={this.state.powerTypes}
        />

        </div>
        ):'Keine Verbindung zum Server möglich'}
      </div>
  );
}
}

export default App;
